import { cn } from '@shared/utils';

/*
 * 底部面板（IonModal sheet 模式）的共用約定。
 *
 * 抽成一處是因為這些值必須在每個面板上一致：把手與標題的間距各調各的，改了其中一個
 * 就會出現「這個面板比較擠」的落差，而那種差異在單獨看某一個面板時察覺不到。
 */

/**
 * 面板停靠點：只有「關閉」與「開啟」兩段，面板高度以 `--height` 指定。
 *
 * 不設中間段：Ionic 的 sheet 停在非最大停靠點時，modal 仍是滿版高度、只是往下位移，
 * 位於底部的 `IonFooter` 會被推出視窗，操作鍵就按不到。
 */
export const SHEET_BREAKPOINTS = [0, 1];
export const SHEET_INITIAL_BREAKPOINT = 1;

/**
 * 面板頂部工具列：讓出拖曳把手的空間。
 *
 * 把手由 IonModal 絕對定位在 `top: 5px`、高 5px，**不佔版面高度**，標題因此會貼上去。
 *
 * 兩個變數都是必要的，因為 iOS mode 的 `ion-title` 是 `position: absolute`、
 * `top: 0`、`height: 100%`、`align-items: center`（title.ios.css）——它**不在文件流裡**，
 * 位置完全由工具列容器的高度決定：
 *
 * - `--min-height` 把容器高度釘死。不釘的話高度會隨**工具列裡有沒有 `ion-buttons`**
 *   而不同，有無按鈕的面板標題位置就會不一致。取值需容納有按鈕時的高度。
 * - `--padding-top` 是 CSS 自訂屬性，**會繼承**到 `ion-title`，把標題往下推離把手。
 */
export const SHEET_TOOLBAR_CLASS = cn(
  '[--padding-top:1.5rem]',
  '[--min-height:3.75rem]',
);

/**
 * 面板外觀。Ionic 元件的外框在 shadow DOM 內，Tailwind class 進不去，只能透過它
 * 暴露的 CSS 變數設定（見 docs/architecture.md 的樣式分工一節）。
 *
 * @param heightClass 面板高度，**必須是字面值**——Tailwind 靜態掃描原始碼產生
 *                    utility，樣板字串組出來的類名它看不到，產出的 CSS 會缺那條規則。
 */
export function sheetClass(heightClass: string) {
  return cn('[--background:var(--color-background-alt)]', heightClass);
}
